import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Table24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58333 5.13333C8.58333 4.71912 8.91912 4.38333 9.33333 4.38333H20C20.4142 4.38333 20.75 4.71912 20.75 5.13333C20.75 5.54755 20.4142 5.88333 20 5.88333H9.33333C8.91912 5.88333 8.58333 5.54755 8.58333 5.13333Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58333 11.5333C8.58333 11.1191 8.91912 10.7833 9.33333 10.7833H20C20.4142 10.7833 20.75 11.1191 20.75 11.5333C20.75 11.9475 20.4142 12.2833 20 12.2833H9.33333C8.91912 12.2833 8.58333 11.9475 8.58333 11.5333Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58333 17.9333C8.58333 17.5191 8.91912 17.1833 9.33333 17.1833H20C20.4142 17.1833 20.75 17.5191 20.75 17.9333C20.75 18.3475 20.4142 18.6833 20 18.6833H9.33333C8.91912 18.6833 8.58333 18.3475 8.58333 17.9333Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 3.5C3.25 3.08579 3.58579 2.75 4 2.75H7.2C7.61421 2.75 7.95 3.08579 7.95 3.5V6.7C7.95 7.11421 7.61421 7.45 7.2 7.45H4C3.58579 7.45 3.25 7.11421 3.25 6.7V3.5ZM4.75 4.25V5.95H6.45V4.25H4.75Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 10C3.25 9.58579 3.58579 9.25 4 9.25H7.2C7.61421 9.25 7.95 9.58579 7.95 10V13.2C7.95 13.6142 7.61421 13.95 7.2 13.95H4C3.58579 13.95 3.25 13.6142 3.25 13.2V10ZM4.75 10.75V12.45H6.45V10.75H4.75Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H7.2C7.61421 15.25 7.95 15.5858 7.95 16V19.2C7.95 19.6142 7.61421 19.95 7.2 19.95H4C3.58579 19.95 3.25 19.6142 3.25 19.2V16ZM4.75 16.75V18.45H6.45V16.75H4.75Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
